var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v(_vm._s(_vm.$t('login.welcome-message')))]),(_vm.appName)?_c('p',{staticClass:"text-success"},[_vm._v(" Logging into "+_vm._s(_vm.appName)+" ")]):_vm._e(),(_vm.redirect)?_c('p',{staticClass:"text-warning"},[_vm._v(" You are being redirected to "+_vm._s(_vm.redirect)+" once you have logged in. ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }